import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
    error: "",
    loginMessage: "",
    loginErrorMessage: "",
    loginStatus: null,
    loginRefreshtoken: null,
  },
  action
) {
  switch (action.type) {
    case homeConstants.SIGN_IN_REQUEST:
      return {
        ...state,
        loginStatus: null,
        isProgress: true,
      };
    case homeConstants.SIGN_IN_SUCCESS: {
      const refreshToken =
        (action.response.data && action.response.data.refreshToken) || "";
      if (action.response.data && action.response.data.refreshToken) {
        sessionStorage.setItem(
          "refreshToken",
          JSON.stringify(action.response.data.refreshToken)
        );
      }
      return {
        data: action.response.data,
        loginRefreshtoken: refreshToken,
        loginStatus: action.response.success,
        loginMessage:
          action.response && action.response.success
            ? "Logged in successfully."
            : action.response.message,
        isProgress: false,
      };
    }
    case homeConstants.SIGN_IN_FAILURE:
      return {
        data: {},
        loginErrorMessage: action?.error?.message,
        loginMessage: action?.error?.message,
        loginRefreshtoken: null,
        loginStatus: action.error.success,
        isProgress: false,
      };
    case homeConstants.RESET_LOGIN_STATUS:
      return {
        ...state,
        loginStatus: null,
        loginMessage: "",
      };
    case homeConstants.RESET_DATA:
      return {
        ...state,
        loginStatus: null,
        data: {},
      };
    default:
      return state;
  }
}
